window.varSpecs = []
window.showSwatches = false 
let csSpecs = JSON.parse(sessionStorage.getItem('variantSpecs'))
let parentProducts = function(){
  if (sessionStorage.getItem('parentItems') === null) {
    return []
  } else {
    return JSON.parse(sessionStorage.getItem('parentItems'))
  }
}
let isPageView = location.href.includes('/cart')

window.checkArraysExist = function (array1, array2) {
  if (array1.length > 0 && array2.length > 0) {
    return true
  }
}

window.createCrossSellItemsArray = function (parentArr, cartHandleArr) {
  let handles = parentArr.filter(item => cartHandleArr.includes(item.handle))
  let dups = new Set()
  let parentItems = handles.filter(el => {
    const duplicate = dups.has(el.id);
    dups.add(el.id);
    return !duplicate;
  })
  let bundleItems = parentItems.map(parent => {
    return parent.related
  })
  let bundleArr = bundleItems.flat()
  let dupSet = new Set()
  let finalArr = bundleArr.filter(el => {
    const duplicated = dupSet.has(el.id);
    dupSet.add(el.id);
    return !duplicated;
  })
  if (window.checkArraysExist(finalArr, cartHandleArr)) {
    return finalArr.filter(item => !cartHandleArr.includes(item.handle))
  }
}

window.getCurrentCartData = function (data) {
  $('#site-cart .cart-items').html($(data).find('#site-cart .cart-items .cart-item'));
  $('#CartScrollTotal').html($(data).find('#CartScrollTotal').html());
  $('#CartTotal').html($(data).find('#CartTotal').html());
  $('#CartDetails').html($(data).find('#CartDetails').html());
  $('[data-cart-cs]').addClass('cart-hide')
  var currentCartItems = $(data).find('#site-cart .cart-items .cart-item')
  var handleArr = $.map(currentCartItems, function(v, i){
    return v.dataset.cartItemHandle
  })
  let crossSellArray = []
  if (window.checkArraysExist(parentProducts(), handleArr)) {
    crossSellArray = window.createCrossSellItemsArray(parentProducts(), handleArr)
  }
  return crossSellArray
}

window.cartCrossSellWidgetCreation = function (data, crossSellItems) {
  let crossSellParentItem = data.product
  for (var property in csSpecs) {
    window.varSpecs.push({'specs': csSpecs[property], 'id': [property]})
  }
  window.showSwatches = window.varSpecs.map(specs => {
    let id = parseInt(specs.id[0])
    if (id === crossSellParentItem.variants[0].id) { 
      $('[data-cart-cs-specs]').html(specs.specs.specs)
      $('[data-cart-cs-specs-page]').html(specs.specs.specs)
      return specs.specs.swatch
    } else {
      return false
    }
  })
  $('[data-cart-cs-btn-check]').attr('style', 'display: none')
  $('[data-cs-cart-add-to-cart]').removeAttr('style', 'border: solid thin #FF5259')
  if (crossSellParentItem.variants.length > 1) {
    if (window.showSwatches[0] === true) {
      $('[data-cs-variant-select-container]').attr('style', 'display: none;')
      $('[data-cs-variant-swatch-container]').removeAttr('style', 'display: none;')
      $('[data-cs-variant-swatch-container]').empty()
      if (isPageView) {
        $('[data-cs-variant-swatch-container]')
          .append('<button data-cs-variant-swatch-button-page class="js-cart-page-swatch-button" onclick="cartSwatchSelect(event, this)">')
        $('[data-cs-variant-swatch-button-page]')
          .append('<div class="js-cart-page-swatch-circle" data-cs-variant-swatch-circle-page></div>')
      } else {
        $('[data-cs-variant-swatch-container]')
          .append('<button data-cs-variant-swatch-button class="js-cart-swatch-button" onclick="cartSwatchSelect(event, this)">')
        $('[data-cs-variant-swatch-button]')
          .append('<div class="js-cart-swatch-circle" data-cs-variant-swatch-circle></div>')
      }
      let swatchButton = isPageView
        ? $('[data-cs-variant-swatch-button-page]')
        : $('[data-cs-variant-swatch-button]')
      let swatchCircle = isPageView
        ? $('[data-cs-variant-swatch-circle-page]')
        : $('[data-cs-variant-swatch-circle]')

      crossSellParentItem.variants.map((variant, i )=> {
        let specsObject = window.varSpecs.find(specs => {
          let id = parseInt(specs.id[0])
          if (id === variant.id) { 
            return specs
          }
        })
        if (i === 0) {
          if (isPageView) {
            swatchButton.attr("id", `js-cart-swatch-button-page-${variant.id}`);
            swatchCircle.attr("id", `js-cart-swatch-circle-page-${variant.id}`);
          } else {
            swatchButton.attr("id", `js-cart-swatch-button-${variant.id}`);
            swatchCircle.attr("id", `js-cart-swatch-circle-${variant.id}`);  
          }
          swatchButton.addClass('cross_sell_card__swatch-button--selected')
          swatchButton.attr('style',`border: solid thin ${specsObject.specs.hex} !important`)
          swatchButton.attr('data-product-id',`${crossSellParentItem.variants[0].id}`)
          swatchButton.attr('data-variant-id',`${variant.id}`)
          swatchButton.attr('data-variant-color',`${specsObject.specs.hex}`)
          swatchCircle.addClass('cross_sell_card__swatch-button-circle--selected')
          swatchCircle.attr('style',`background: ${specsObject.specs.hex}`)
        } else {
          var buttonClone = swatchButton.clone()
          var circle = buttonClone.children()
          if (isPageView) {
            buttonClone.attr("id", `js-cart-swatch-button-page-${variant.id}`);
            circle.attr("id", `js-cart-swatch-circle-page-${variant.id}`);
          } else {
            buttonClone.attr("id", `js-cart-swatch-button-${variant.id}`);
            circle.attr("id", `js-cart-swatch-circle-${variant.id}`);
          }
          buttonClone.removeClass('cross_sell_card__swatch-button--selected')
          buttonClone.addClass('cross_sell_card__swatch-button')
          buttonClone.removeAttr('style',`border: solid thin ${specsObject.specs.hex} !important`)
          buttonClone.attr('data-variant-id',`${variant.id}`)
          buttonClone.attr('data-variant-color',`${specsObject.specs.hex}`)
          circle.removeClass('cross_sell_card__swatch-button-circle--selected')
          circle.addClass('cross_sell_card__swatch-button-circle')
          circle.attr('style',`background: ${specsObject.specs.hex}`)
          swatchButton.after(buttonClone)
        }
      })
    } else {
      $('[data-cs-variant-swatch-container]').attr('style', 'display: none;')
      $('[data-cs-cart-variant-select]').empty()
      $('[data-cs-cart-variant-select]').append('<option data-cs-variant-select-option></option>')
      let variants = crossSellParentItem.variants;

      if(variants.length > 1){
        for (let i = 0; i < variants.length; i++) {
          let variant = variants[i];
          let referenceNode = document.querySelector('[data-cs-variant-select-option]');
          var clone = referenceNode.cloneNode();
          clone.setAttribute('value', variant.id);
          clone.textContent = variant.title;

          referenceNode.parentNode.insertBefore(clone, referenceNode.nextSibling);

          if(i == 0){
            referenceNode.remove();
          }
        }
        $('[data-cs-cart-variant-select]').prop('selectedIndex', 0).selectric('refresh');
      }else{
        $('[data-cs-variant-select-container]').removeAttr('style', 'display: none;')
        $('[data-cs-variant-select-option]').val(variants[0].id)
        $('[data-cs-variant-select-option]').text(variants[0].title)
        $('[data-cs-cart-variant-select]').prop('selectedIndex', 0).selectric('refresh');
      }
      
      // crossSellParentItem.variants.map((variant, i )=> {
      //   if (i == 0) {
      //     $('[data-cs-variant-select-container]').removeAttr('style', 'display: none;')
      //     $('[data-cs-variant-select-option]').val(variant.id)
      //     $('[data-cs-variant-select-option]').text(variant.title)
      //     $('[data-cs-cart-variant-select]').prop('selectedIndex', 0).selectric('refresh');
      //   } else {
      //     var clone = $('[data-cs-variant-select-option]').clone()
      //     clone.val(variant.id)
      //     clone.text(variant.title)
      //     $('[data-cs-variant-select-option]').after(clone)
      //   }
      // })
    }
  } else {
    $('[data-cs-variant-select-container]').attr('style', 'display: none;')
    $('[data-cs-variant-swatch-container]').attr('style', 'display: none;')
  }

  let dis = parseFloat(crossSellItems[0].discount)
  let percent = 100 - (dis * 100)
  if (percent === 0) {
    $('[data-cart-cs-discount-container]').attr('style', 'display: none;')
    $('[data-cart-cs-compare-price-container]').attr('style', 'display: none;')
    $('[data-cart-cs-bundle-price]').text(crossSellParentItem.variants[0].price)	
  } else {
    $('[data-cart-cs-discount-container]').removeAttr('style', 'display: none;')
    $('[data-cart-cs-price-container]').removeAttr('style', 'display: none;')
    $('[data-cart-cs-discount]').text(percent)
    let bundlePrice = parseFloat(crossSellItems[0].discount) * crossSellParentItem.variants[0].price
    let fixedPrice = bundlePrice.toFixed(2)
    $('[data-cart-cs-bundle-price]').text(`${fixedPrice}${" "}`)		  
  }
  $('[data-cs-cart-add-to-cart]').attr('name', `${crossSellParentItem.variants[0].id}`)
  $('[data-cart-cs-header]').text(crossSellItems[0].header)
  $('[data-cart-cs-vanity]').text(crossSellParentItem.title)	
  $('[data-cart-cs-img]').empty()
  $('[data-cart-cs-img]').append(`<image src=${crossSellParentItem.image.src} class="cart-cross-sell-card__image" alt=${crossSellParentItem.image.alt}></image>`)	
  $('[data-cart-cs-compare-price]').text(crossSellParentItem.variants[0].price)		
}

window.cartCrossSellWidget = function() {
  $.ajax({
    url: '/cart',
    success: function(data) {
      let crossSellItems = window.getCurrentCartData(data)
      if (crossSellItems && crossSellItems.length > 0) {
        let getUrl = ''
        let currentUrl = location.href
        if (currentUrl.includes('/products')) {
          getUrl = `${crossSellItems[0].handle}.json`
        } else {
          getUrl = `https://latercase.com/products/${crossSellItems[0].handle}.json`
        }      
        $.ajax({
          type: "GET",
          url: getUrl,
          success: function (data) {
            window.cartCrossSellWidgetCreation(data, crossSellItems)
            $('[data-cart-cs]').removeClass('cart-hide')
            $('[data-cart-cs-btn-check]').attr('style', 'display: none')
            $('[data-cs-cart-add-to-cart]').removeAttr('style', 'border: solid thin #FF5259')    
          },
          error: function (data) {
            $('[data-cart-cs]').addClass('cart-hide')
          }
        })
      } else {
        $('[data-cart-cs]').addClass('cart-hide')
      }
      window.sidebarCartAjaxFunctions();
      setTimeout(function(){
        window.displayCheckoutButtons()
      }, 200);
      $cartCount = $('.cart-menu .count'),
      $cartCount.text(parseInt($cartCount.text()) + 1);
      $('#site-cart .subtitle').html($('#site-cart .subtitle').data('added-singular').replace(/{{ count }}|count|{{count}}/, 1));
      $('.site-cart-handle a').trigger('click');
    }
  });
}

window.sidebarCartAjaxFunctions = function() {
	$('#site-cart').find('.cart-item:not(.ajax-init)').each(function(){

		$(this).addClass('ajax-init');

		var $remove = $(this).find('.remove');

		$remove.on('click', function(e){
      e.preventDefault();
			var $item = $(this).parent();
			$item.addClass('remove-process');
			
			let parentItemArr =  sessionStorage.getItem('parentItems') === null ? [] : JSON.parse(sessionStorage.getItem('parentItems'))
      let removeItem = $item[0].dataset.cartItemHandle
      let removeItemKey = $item[0].dataset.cartItemKey
			$.ajax({
        method: "POST",
        url: '/cart/change.js',
        data: {
          'quantity': '0',
          'id': removeItemKey
        },
        dataType: 'json',
				success: function(resp) {
					if (parentItemArr.some(parent => parent.handle == removeItem)) {
						location.reload()
					} else {
            $.ajax({
              method: "GET",
              url: '/cart',
              success: function (data) {
                $('.site-cart-heading').html($(data).find('.site-cart-heading').html());
                $('#CartTotal').html($(data).find('#CartTotal').html());
                $('#CartScrollTotal').html($(data).find('#CartScrollTotal').html());
                $('#CartDetails').html($(data).find('#CartDetails').html());
                $('.site-cart-handle .count-holder').html($(data).find('.site-cart-handle .count-holder').html());
      
                $(data).find('.cart-item .remove').each(function(index) {
                  $('#site-cart').find('[data-key="'+$(this).data('key')+'"]').data('href', $(this).attr('href'))
                })
                $item.slideUp(150, function(){
                  $(this).remove();
                });
                var cartQuant = parseInt($('.count-holder .count').text())
                if (cartQuant == 0) {
                  $('[data-cart-cs]').addClass('cart-hide')
                }
                let crossSellItems = []
                var currentCartItems = $(data).find('#site-cart .cart-items .cart-item')
                var handleArr = $.map(currentCartItems, function(v, i){
                  return v.dataset.cartItemHandle
                })
                if (window.checkArraysExist(parentProducts(), handleArr)) {
                  crossSellItems = window.createCrossSellItemsArray(parentProducts(), handleArr)
                }
                let getUrl = ''
                if (crossSellItems && crossSellItems.length > 0) {
                  let currentUrl = location.href
                  if (currentUrl.includes('/products')) {
                    getUrl = `${crossSellItems[0].handle}.json`
                  } else {
                    getUrl = `https://latercase.com/products/${crossSellItems[0].handle}.json`
                  }      
                	$.ajax({
                		method: "GET",
                		url: getUrl,
                		success: function (data) {
                      window.cartCrossSellWidgetCreation(data, crossSellItems)
                			//If var select changed in cart cr-widget updated specs
                			if (currentUrl.includes('/cart')) {
                        selector = $('[data-cs-cart-variant-select-page]')
                        specsContainer = $('[data-cart-cs-specs-page]')
                      } else {
                        selector = $('[data-cs-cart-variant-select]')
                        specsContainer = $('[data-cart-cs-specs]')
                      }
                      selector.selectric().on('change', function() {
                        let currentVar = selector.val()
                        window.varSpecs.map(meta => {
                          if (meta.id == currentVar) {
                            specsContainer.html(meta.specs.specs)
                          }
                        })
                      })
                      $('[data-cart-cs]').removeClass('cart-hide')	
                      window.displayCheckoutButtons()
                		},
                		error: function (data) {
                			$('[data-cart-cs]').addClass('cart-hide')
                		}
                	})
                }
              },
              error: function (resp) {
                console.log('something went wrong', resp)
              }
            })
          }
        }
			})
		});
	});
}

let selectedVariantId = ''

window.displayCheckoutButtons = function() {
  let largeCheckoutButton = document.getElementById('js-sidecart-no-scroll')
  let smallCheckoutButton = document.getElementById('js-sidecart-scroll-option')
  largeCheckoutButton.setAttribute('style', 'display: none')
  smallCheckoutButton.setAttribute('style', 'display: none')
  largeCheckoutButton.firstElementChild.setAttribute('id', '')
  smallCheckoutButton.firstElementChild.setAttribute('id', '')

  let sideCart = document.getElementById('js-sidecart-scrolling')
  let divHeight = sideCart.offsetHeight
  let docHeight = window.innerHeight
  if (divHeight > docHeight) {
    largeCheckoutButton.setAttribute('style', 'display: none')
    smallCheckoutButton.firstElementChild.setAttribute('id', 'CartDetails')
    smallCheckoutButton.setAttribute('style', 'display: block')
  } else {
    smallCheckoutButton.setAttribute('style', 'display: none')
    largeCheckoutButton.firstElementChild.setAttribute('id', 'CartDetails')
    largeCheckoutButton.setAttribute('style', 'display: block')
  }
}

window.cartSwatchSelect = function (event, object) {
  event.preventDefault();
  let dataset = object.dataset
  let allButtons = []
  let allSwatches = []
  let selectedButton = ''
  let selectedCircle = ''
  if (isPageView) {
    allButtons = document.querySelectorAll('.js-cart-page-swatch-button')
    allSwatches = document.querySelectorAll('.js-cart-page-swatch-circle')
    selectedButton = document.getElementById(`js-cart-swatch-button-page-${dataset.variantId}`)
    selectedCircle = document.getElementById(`js-cart-swatch-circle-page-${dataset.variantId}`)
  } else {
    allButtons = document.querySelectorAll('.js-cart-swatch-button')
    allSwatches = document.querySelectorAll('.js-cart-swatch-circle')
    selectedButton = document.getElementById(`js-cart-swatch-button-${dataset.variantId}`)
    selectedCircle = document.getElementById(`js-cart-swatch-circle-${dataset.variantId}`)
  }
  for (let i = 0; i < allButtons.length; i++) {
    allButtons[i].classList.remove('cross_sell_card__swatch-button--selected')
    allButtons[i].classList.add('cross_sell_card__swatch-button')
    allButtons[i].style.border = 'none';
  }
  for (let i = 0; i < allSwatches.length; i++) {
    allSwatches[i].classList.remove('cross_sell_card__swatch-button-circle--selected')
    allSwatches[i].classList.add('cross_sell_card__swatch-button-circle')
  }

  selectedButton.classList.remove('cross_sell_card__swatch-button')
  selectedButton.classList.add('cross_sell_card__swatch-button--selected')
  selectedButton.style.border = `solid thin ${dataset.variantColor}`
  selectedCircle.classList.remove('cross_sell_card__swatch-button-circle')
  selectedCircle.classList.add('cross_sell_card__swatch-button-circle--selected')
  selectedVariantId = dataset.variantId

  window.varSpecs.map(meta => {
    if (meta.id == selectedVariantId) {
      if (isPageView) {
        $('[data-cart-cs-specs-page]').html(meta.specs.specs)
      } else {
        $('[data-cart-cs-specs]').html(meta.specs.specs)
      }
    }
  })
}

let cartBundleButton = $('[data-cs-cart-add-to-cart]')
$('[data-cs-cart-add-to-cart]').click(function(e) {
  e.preventDefault()
  let items = []
  let item = {
    quantity: 1,
  }
  let firstVar = $('[data-cs-cart-add-to-cart]').attr('name')
  let currentVar = ''
  if(Array.isArray(window.showSwatches)){
    currentVar = $('[data-cs-cart-variant-select]').val()
  }else{
    if (window.showSwatches) { 
      currentVar = selectedVariantId
    } else {
      currentVar = $('[data-cs-cart-variant-select]').val()
    }
  }
  currentVar !== '' ? item.id = currentVar : item.id = parseInt(firstVar)
  items.push(item)
  $('[data-cs-cart-add-to-cart]').attr('style', 'border: solid thin #FF5259')
  $('[data-cart-cs-btn-check]').attr('style', 'display: flex')
  $.ajax({
  	type: "POST",
  	url: '/cart/add.js',
  	data: {'items': items},
  	dataType: 'json',
  	success: function(data) {
      if (location.href.includes('/cart')) {
        location.reload();
      } else {
        items = []
        cartCrossSellWidget()
      }
  	},
  	error: function(data) {
  		alert(data.responseJSON.description);
  	}
  })
})
